// extracted by mini-css-extract-plugin
export var container = "styles-module--container--kc41j";
export var maxWidthXs = "styles-module--max-width-xs--37QFV";
export var isFake = "styles-module--isFake--1NJAs";
export var maxWidthSm = "styles-module--max-width-sm--2PErL";
export var maxWidthMd = "styles-module--max-width-md--1UOO-";
export var maxWidthLg = "styles-module--max-width-lg--A5F1n";
export var maxWidthXl = "styles-module--max-width-xl--2BAFm";